export enum ReportLogActionEnum {
  WAITING = 'WAITING',
  INFORMED_WRITER = 'INFORMED_WRITER',
  SENT_MSG_WRITER = 'SENT_MSG_WRITER',
  SENT_MSG_REPORTER = 'SENT_MSG_REPORTER',
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
  SUCCESS = 'SUCCESS',
}
